module.exports = __webpack_public_path__ + "assets/img/BS.045a30dc.png";